import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { useId } from 'react';
import { PriceDisplay } from '../price/PriceDisplay';
import { FSC_TIER_NAMES } from './fscTierNames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FscTierSelector({
  options,
  selectedTier,
  currencyCode,
  onSelectTier
}) {
  const labelId = useId();
  const groupName = useId();
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "300",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      typography: "heading-100",
      id: labelId,
      marginBlock: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "fscTierSelector.title"
      })
    }), /*#__PURE__*/_jsx(Grid, {
      role: "radiogroup",
      "aria-labelledby": labelId,
      children: options.map(({
        tier,
        pricePerSeat
      }) => /*#__PURE__*/_jsx(GridItem, {
        size: {
          xs: 12,
          sm: 4
        },
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(SelectableBox, {
          inlineSize: "100%",
          flush: true,
          type: "radio",
          name: groupName,
          selectionMarkLocation: "top-right",
          selected: tier === selectedTier,
          onClick: () => {
            if (tier !== selectedTier) onSelectTier(tier);
          },
          "data-selenium-class": `${tier}-tier-selector-button`,
          children: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            alignItems: "start",
            paddingBlock: "400",
            paddingInlineStart: "300",
            children: [/*#__PURE__*/_jsx(Text, {
              typography: "heading-50",
              children: FSC_TIER_NAMES[tier]
            }), pricePerSeat !== undefined && /*#__PURE__*/_jsx(Text, {
              typography: "body-125",
              children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "fscTierSelector.pricePerSeat",
                options: {
                  price: /*#__PURE__*/_jsx(PriceDisplay, {
                    price: pricePerSeat,
                    currencyCode: currencyCode
                  })
                }
              })
            })]
          })
        })
      }, tier))
    })]
  });
}